<template>
  <section class="content-header">
    <h1>Informe de tramitación</h1>
  </section>

  <section class="content">
    <div class="box box-primary">
      <div class="box-body">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label for="compania">Compañías</label>
              <MultiSelect v-model="companyiasSeleccionadas" inputId="compania"
                :options="companyias" optionLabel="nombre" optionValue="id_companyia"
                filter display="chip" :maxSelectedLabels="2"
                selectedItemsLabel="{0} compañías seleccionadas"
                placeholder="Todas las compañías"
                scrollHeight="400px" class="w-100" />
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-group">
              <label for="usuario">Tramitadores</label>
              <MultiSelect v-model="usuariosSeleccionados" inputId="usuario"
                :options="usuarios" optionLabel="nombre" optionValue="id_usuario"
                filter display="chip" :maxSelectedLabels="2"
                selectedItemsLabel="{0} tramitadores seleccionados"
                placeholder="Todos los tramitadores"
                scrollHeight="400px" class="w-100" />
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-group">
              <label for="tipo_danyo">Tipo de daño</label>
              <Dropdown v-model="tipoDanyo" inputId="tipo_danyo"
                :options="tiposDanyo" optionLabel="nombre" optionValue="id_tipo_danyo"
                filter placeholder="Todos" class="w-100" />
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-group">
              <label for="fecha_inicio">Fecha inicio</label>
              <Calendar v-model="fechaInicio" inputId="fecha_inicio"
                dateFormat="dd/mm/yy" showIcon class="w-100" />
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-group">
              <label for="fecha_fin">Fecha fin</label>
              <Calendar v-model="fechaFin" inputId="fecha_fin"
                dateFormat="dd/mm/yy" showIcon class="w-100" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="botonera">
              <button class="btn btn-primary" @click="cargarInforme('pdf')" :disabled="generando">
                <i class="fa" :class="generando === 'pdf' ? 'fa-spinner fa-spin' : 'fa-file-pdf-o'"></i>
                Generar PDF
              </button>
              <button class="btn btn-success" @click="cargarInforme('xls')" :disabled="generando">
                <i class="fa" :class="generando === 'xls' ? 'fa-spinner fa-spin' : 'fa-file-excel-o'"></i>
                Generar Excel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <form id="FormInforme" method="post" style="display:none"></form>
    <iframe name="iframeInforme" style="display:none"></iframe>
  </section>
</template>

<script>
import { PwgsApi } from '../../../services/PwgsApi';
import MultiSelect from 'primevue/multiselect';
import Dropdown from 'primevue/dropdown';
import Calendar from 'primevue/calendar';

export default {
  components: { MultiSelect, Dropdown, Calendar },

  data() {
    const hoy = new Date();
    return {
      companyias: [],
      companyiasSeleccionadas: [],
      usuarios: [],
      usuariosSeleccionados: [],
      tiposDanyo: [],
      tipoDanyo: '',
      fechaInicio: new Date(hoy.getFullYear(), hoy.getMonth(), 1),
      fechaFin: hoy,
      generando: false
    };
  },

  methods: {
    formatearFecha(fecha) {
      if (!fecha) return '';
      const d = String(fecha.getDate()).padStart(2, '0');
      const m = String(fecha.getMonth() + 1).padStart(2, '0');
      return `${d}/${m}/${fecha.getFullYear()}`;
    },

    async cargarInforme(tipo) {
      const destino = tipo === 'pdf' ? 'VentanaInforme' : 'iframeInforme';
      if (tipo === 'pdf') window.open('', 'VentanaInforme');

      this.generando = tipo;
      try {
        const api = new PwgsApi();

        const html = await api.post('informes/informe_tramitacion', {
          tipo_respuesta: tipo,
          id_companyia: '',
          id_usuario: '',
          id_tipo_danyo: this.tipoDanyo,
          fecha_inicio: this.formatearFecha(this.fechaInicio),
          fecha_fin: this.formatearFecha(this.fechaFin)
        });

        const doc = new DOMParser().parseFromString(html, 'text/html');
        const formOrigen = doc.querySelector('#form_informe');
        if (!formOrigen) {
          console.error('La API no devolvió el formulario esperado', html);
          return;
        }

        let direccion = localStorage.getItem('direccion');
        if (direccion == 'null.pwgs.app') direccion = 'pwgs5.local';

        const form = document.getElementById('FormInforme');
        form.innerHTML = '';
        form.target = destino;
        form.action = 'https://' + direccion + formOrigen.getAttribute('action');

        const anyadir = (nombre, valor) => {
          const i = document.createElement('input');
          i.type = 'hidden';
          i.name = nombre;
          i.value = valor;
          form.appendChild(i);
        };

        // Del HTML de la API solo las fechas y el tipo de daño.
        // Compañías y tramitadores son arrays, los montamos nosotros.
        formOrigen.querySelectorAll('input').forEach(input => {
          if (['fecha_inicio', 'fecha_fin', 'tipo_danyo'].includes(input.name)) {
            anyadir(input.name, input.value);
          }
        });

        this.companyiasSeleccionadas.forEach(id => anyadir('compania[]', id));
        this.usuariosSeleccionados.forEach(id => anyadir('usuario_tramitador[]', id));

        anyadir('tipo_documento_generado', tipo);
        anyadir('Generar', 'Generar documento');

        form.submit();
      } finally {
        this.generando = false;
      }
    },

    async cargarFiltros() {
      const api = new PwgsApi();
      const respuesta = await api.get('informes/informe_tramitacion');
      const filtros = respuesta.filtros || (respuesta.informes && respuesta.informes.filtros) || [];

      const fCompanyias = filtros.find(f => f.nombre_campo === 'id_companyia');
      const fUsuarios = filtros.find(f => f.nombre_campo === 'id_usuario');
      const fTiposDanyo = filtros.find(f => f.nombre_campo === 'id_tipo_danyo');

      // En los multiselect, no seleccionar nada ya significa "todos"
      this.companyias = fCompanyias
        ? fCompanyias.valores.filter(c => c.id_companyia !== '')
        : [];
      this.usuarios = fUsuarios
        ? fUsuarios.valores.filter(u => u.id_usuario !== '')
        : [];

      this.tiposDanyo = fTiposDanyo ? fTiposDanyo.valores : [];
      this.tipoDanyo = '';
    }
  },

  mounted() {
    this.cargarFiltros();
  }
};
</script>

<style scoped>
.form-group label {
  display: block;
  font-weight: 600;
  margin-bottom: 5px;
}

.w-100 :deep(.p-multiselect),
.w-100 :deep(.p-dropdown),
.w-100 :deep(.p-calendar),
.w-100 :deep(.p-inputtext) {
  width: 100%;
}

.botonera {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>